import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function CreateCard() {
  const [form, setForm] = useState({
    title: "",
    description: "",
    url: "",
    position: 1,
    image: null,
    taxonomy: "courses",
    button_text: "", // new field
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("title", form.title);
      if (form.description) formData.append("description", form.description);
      if (form.url) formData.append("url", form.url);
      formData.append("position", form.position);
      formData.append("taxonomy", form.taxonomy);
      if (form.image) formData.append("image", form.image);
      if (form.button_text) formData.append("button_text", form.button_text); // include button_text

      await axios.post(`${process.env.REACT_APP_API_URL}/api/cards`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage("Card created successfully!");
      setForm({
        title: "",
        description: "",
        url: "",
        position: 1,
        image: null,
        taxonomy: "courses",
        button_text: "",
      });

      navigate("/xl-admin/cards");
    } catch (err) {
      console.error("Error details:", err.response || err.message);
      setMessage(
        "Error creating card. " +
          (err.response?.data?.message || err.message || "")
      );
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h3 className="mb-0">Create a New Card</h3>
      </div>

      {message && <div className="alert alert-info">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">URL</label>
          <input
            type="url"
            name="url"
            value={form.url}
            onChange={handleChange}
            className="form-control"
            placeholder="https://example.com"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Position</label>
          <select
            name="position"
            value={form.position}
            onChange={handleChange}
            className="form-control"
          >
            {[...Array(7).keys()].map((i) => (
              <option key={i} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Taxonomy</label>
          <select
            name="taxonomy"
            value={form.taxonomy}
            onChange={handleChange}
            className="form-control"
          >
            <option value="courses">Courses</option>
            <option value="features">Features</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Button Text (optional)</label>
          <input
            type="text"
            name="button_text"
            value={form.button_text}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Image (optional)</label>
          <input
            type="file"
            name="image"
            className="form-control"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Submitting..." : "Create Card"}
        </button>
      </form>
    </div>
  );
}
